import * as actions from './actionTypes';
import Megatron from '../../../../../packages/megatron/src/megatron';
import {PRE_REGISTER_API} from '../../constants';

export const preRegisterUser = data => {
  return dispatch => {
    Megatron({
      name: 'pre register api',
      url: PRE_REGISTER_API,
      type: 'POST',
      credentials: 'omit',
      requestData: data,
    })
      .then(response => {
        if (response.success) {
          dispatch(preRegisterSuccess());
        } else {
          dispatch(preRegisterFail(response.message));
        }
      })
      .catch(error => {
        dispatch(preRegisterFail(error));
      });
  };
};

export const preRegisterSuccess = () => {
  return {
    type: actions.PREREGISTER_SUCCESS,
  };
};

export const preRegisterFail = error => {
  return {
    type: actions.PREREGISTER_FAIL,
    error: error,
  };
};
